module.exports = __webpack_public_path__ + "media/images/mstile-144x144-20dd5c9d112b55a641ea583a75a7436c.png";